import { DateTime } from "luxon";
import { ResolvablePromise } from "./resolvable-promise";
import { coalesceDateTime } from "./date-time";
export class KeyedExpiryTokenCache {
    generateNewToken;
    existingTokenFetcher;
    tokenFetchPromiseMap = new Map();
    constructor(generateNewToken, existingTokenFetcher) {
        this.generateNewToken = generateNewToken;
        this.existingTokenFetcher = existingTokenFetcher;
    }
    async getToken(key, ...args) {
        let tokenFetchPromise = this.tokenFetchPromiseMap.get(key);
        if (tokenFetchPromise) {
            // Someone either already has a token or is in the process of getting one
            // Wait for them to finish, then check for validity
            const currentToken = await tokenFetchPromise;
            if (currentToken.expiresAt > DateTime.now()) {
                // Current token is valid, return it
                return currentToken;
            }
            else {
                // Current token expired, start a new promise
                tokenFetchPromise = new ResolvablePromise();
                this.tokenFetchPromiseMap.set(key, tokenFetchPromise);
                try {
                    const newToken = await this.generateNewToken(key, ...args);
                    tokenFetchPromise.resolve(newToken);
                    return newToken;
                }
                catch (e) {
                    tokenFetchPromise.reject(e);
                    tokenFetchPromise = undefined;
                    throw e;
                }
            }
        }
        else {
            // No one has a token, start a new promise
            tokenFetchPromise = new ResolvablePromise();
            this.tokenFetchPromiseMap.set(key, tokenFetchPromise);
            try {
                const existingToken = await this.getExistingToken(key);
                if (existingToken?.expiresAt) {
                    const expiresAt = coalesceDateTime(existingToken.expiresAt);
                    if (expiresAt && expiresAt > DateTime.now().minus({ minute: 1 })) {
                        const newToken = { ...existingToken, expiresAt };
                        tokenFetchPromise.resolve(newToken);
                        return newToken;
                    }
                }
                const newToken = await this.generateNewToken(key, ...args);
                tokenFetchPromise.resolve(newToken);
                return newToken;
            }
            catch (e) {
                tokenFetchPromise.reject(e);
                tokenFetchPromise = undefined;
                throw e;
            }
        }
    }
    async getExistingToken(key) {
        const existingToken = await this.existingTokenFetcher(key);
        if (existingToken?.expiresAt) {
            const expiresAt = coalesceDateTime(existingToken.expiresAt);
            if (expiresAt && expiresAt > DateTime.now()) {
                return { ...existingToken, expiresAt };
            }
        }
        return null;
    }
    clearToken(key) {
        this.tokenFetchPromiseMap.delete(key);
    }
}
//# sourceMappingURL=keyed-expiry-token-cache.js.map